<h1 mat-dialog-title>
  @if (data.mode === 'confirmation') {
    Wil je de geselecteerde passagiers verwijderen?
  } @else {
    Niet alle passagiers konden worden verwijderd
  }
</h1>

<div mat-dialog-content>
  @if (data.mode === 'confirmation') {
    <p class="dialog-text">De geselecteerde passagiers worden binnenkort verwijderd.</p>
    <div class="bulk-delete-users">
      @for (user of data.users ?? []; track user.id) {
        <div class="bulk-delete-user">
          <strong>{{ user.name || 'Onbekend' }}</strong>
          <span><strong>E-mail:</strong> {{ user.email || '-' }}</span>
          <span><strong>Telefoon:</strong> {{ user.phone || user.phoneNumber || '-' }}</span>
          @if (user.hiddenDate) {
            <span><strong>Verborgen sinds:</strong> {{ user.hiddenDate }}</span>
          }
        </div>
      }
    </div>
    <p class="dialog-text bulk-delete-warning">Deze actie kan niet worden teruggedraaid.</p>
  } @else {
    <div class="bulk-delete-result">
      @if (data.queued?.length) {
        <section class="bulk-delete-result-group queued">
          <h2>
            {{ data.queued.length }}
            {{
              data.queued.length === 1
                ? 'passagier wordt binnenkort verwijderd'
                : 'passagiers worden binnenkort verwijderd'
            }}
          </h2>
          @for (user of data.queued; track user.id) {
            <div class="bulk-delete-user">
              <strong>{{ user.name || 'Onbekend' }}</strong>
              <span><strong>E-mail:</strong> {{ user.email || '-' }}</span>
              <span><strong>Telefoon:</strong> {{ user.phone || user.phoneNumber || '-' }}</span>
              @if (user.hiddenDate) {
                <span><strong>Verborgen sinds:</strong> {{ user.hiddenDate }}</span>
              }
            </div>
          }
        </section>
      }
      @if (data.skipped?.length) {
        <section class="bulk-delete-result-group skipped">
          <h2>
            {{ data.skipped.length }}
            {{
              data.skipped.length === 1
                ? 'passagier had al een verwijderingsverzoek'
                : 'passagiers hadden al een verwijderingsverzoek'
            }}
          </h2>
          @for (user of data.skipped; track user.id) {
            <div class="bulk-delete-user">
              <strong>{{ user.name || 'Onbekend' }}</strong>
              <span><strong>E-mail:</strong> {{ user.email || '-' }}</span>
              <span><strong>Telefoon:</strong> {{ user.phone || user.phoneNumber || '-' }}</span>
              @if (user.hiddenDate) {
                <span><strong>Verborgen sinds:</strong> {{ user.hiddenDate }}</span>
              }
            </div>
          }
        </section>
      }
      @if (data.failed?.length) {
        <section class="bulk-delete-result-group failed">
          <h2>
            {{ data.failed.length }}
            {{
              data.failed.length === 1
                ? 'passagier kon niet worden verwijderd'
                : 'passagiers konden niet worden verwijderd'
            }}
          </h2>
          @for (user of data.failed; track user.id) {
            <div class="bulk-delete-user">
              <strong>{{ user.name || 'Onbekend' }}</strong>
              <span><strong>E-mail:</strong> {{ user.email || '-' }}</span>
              <span><strong>Telefoon:</strong> {{ user.phone || user.phoneNumber || '-' }}</span>
              @if (user.hiddenDate) {
                <span><strong>Verborgen sinds:</strong> {{ user.hiddenDate }}</span>
              }
            </div>
          }
        </section>
      }
    </div>
  }
</div>

<div mat-dialog-actions align="end">
  @if (data.mode === 'confirmation') {
    <button mat-button class="error-color" [mat-dialog-close]="true">Ja, verwijderen</button>
    <button mat-flat-button [mat-dialog-close]="false">Nee, niet verwijderen</button>
  } @else {
    <button mat-flat-button mat-dialog-close>Sluiten</button>
  }
</div>
